import {Component, ViewChild, OnInit} from '@angular/core';
import {MatPaginator, MatSort, MatTableDataSource} from '@angular/material';
import {SelectionModel} from '@angular/cdk/collections';
import * as XLSX from 'xlsx';
import { Router } from '@angular/router';
import * as firebase from 'firebase';

@Component({
  selector: 'app-adminlistados-usuarios',
  templateUrl: './adminlistados-usuarios.component.html',
  styleUrls: ['./adminlistados-usuarios.component.scss']
})
export class AdminlistadosUsuariosComponent implements OnInit {

  //seleccionarTodo: boolean = true;

  // variable para gestionar los estados de los checkbox del modal mostrar/ocultar columnas
  data = [
   {'id': 'checkbox_tut_1_email', 'selected': true, 'name': 'tut_1_email', 'displayed_column_name': 'tut_1_email'},
   {'id': 'checkbox_password', 'selected': true, 'name': 'password', 'displayed_column_name': 'password'},
   {'id': 'checkbox_tut_1_dni', 'selected': true, 'name': 'tut_1_dni', 'displayed_column_name': 'tut_1_dni'},
   {'id': 'checkbox_tut_1_apellido1', 'selected': true, 'name': 'tut_1_apellido1', 'displayed_column_name': 'tut_1_apellido1'},
   {'id': 'checkbox_tut_1_apellido2', 'selected': true, 'name': 'tut_1_apellido2', 'displayed_column_name': 'tut_1_apellido2'},
   {'id': 'checkbox_tut_1_nombre', 'selected': true, 'name': 'tut_1_nombre', 'displayed_column_name': 'tut_1_nombre'},
   {'id': 'checkbox_tut_1_telefono1', 'selected': true, 'name': 'tut_1_telefono1', 'displayed_column_name': 'tut_1_telefono1'},
   {'id': 'checkbox_tut_1_telefono2', 'selected': true, 'name': 'tut_1_telefono2', 'displayed_column_name': 'tut_1_telefono2'},
   {'id': 'checkbox_tut_2_email', 'selected': true, 'name': 'tut_2_email', 'displayed_column_name': 'tut_2_email'},
   {'id': 'checkbox_tut_2_dni', 'selected': true, 'name': 'tut_2_dni', 'displayed_column_name': 'tut_2_dni'},
   {'id': 'checkbox_tut_2_apellido1', 'selected': true, 'name': 'tut_2_apellido1', 'displayed_column_name': 'tut_2_apellido1'},
   {'id': 'checkbox_tut_2_apellido2', 'selected': true, 'name': 'tut_2_apellido2', 'displayed_column_name': 'tut_2_apellido2'},
   {'id': 'checkbox_tut_2_nombre', 'selected': true, 'name': 'tut_2_nombre', 'displayed_column_name': 'tut_2_nombre'},
   {'id': 'checkbox_tut_2_telefono1', 'selected': true, 'name': 'tut_2_telefono1', 'displayed_column_name': 'tut_2_telefono1'},
   {'id': 'checkbox_tut_2_telefono2', 'selected': true, 'name': 'tut_2_telefono2', 'displayed_column_name': 'tut_2_telefono2'},
   {'id': 'checkbox_domicilio_calle_1', 'selected': true, 'name': 'domicilio_calle_1', 'displayed_column_name': 'domicilio_calle_1'},
   {'id': 'checkbox_domicilio_numero_1', 'selected': true, 'name': 'domicilio_numero_1', 'displayed_column_name': 'domicilio_numero_1'},
   {'id': 'checkbox_domicilio_escalera_1', 'selected': true, 'name': 'domicilio_escalera_1', 'displayed_column_name': 'domicilio_escalera_1'},
   {'id': 'checkbox_domicilio_piso_1', 'selected': true, 'name': 'domicilio_piso_1', 'displayed_column_name': 'domicilio_piso_1'},
   {'id': 'checkbox_domicilio_puerta_1', 'selected': true, 'name': 'domicilio_puerta_1', 'displayed_column_name': 'domicilio_puerta_1'},
   {'id': 'checkbox_domicilio_poblacion_1', 'selected': true, 'name': 'domicilio_poblacion_1', 'displayed_column_name': 'domicilio_poblacion_1'},
   {'id': 'checkbox_domicilio_codigo_postal_1', 'selected': true, 'name': 'domicilio_codigo_postal_1', 'displayed_column_name': 'domicilio_codigo_postal_1'},
   {'id': 'checkbox_domicilio_provincia_1', 'selected': true, 'name': 'domicilio_provincia_1', 'displayed_column_name': 'domicilio_provincia_1'},
   {'id': 'checkbox_domicilio_telefono_1', 'selected': true, 'name': 'domicilio_telefono_1', 'displayed_column_name': 'domicilio_telefono_1'},
   {'id': 'checkbox_domicilio2_calle_1', 'selected': true, 'name': 'domicilio2_calle_1', 'displayed_column_name': 'domicilio2_calle_1'},
   {'id': 'checkbox_domicilio2_numero_1', 'selected': true, 'name': 'domicilio2_numero_1', 'displayed_column_name': 'domicilio2_numero_1'},
   {'id': 'checkbox_domicilio2_escalera_1', 'selected': true, 'name': 'domicilio2_escalera_1', 'displayed_column_name': 'domicilio2_escalera_1'},
   {'id': 'checkbox_domicilio2_piso_1', 'selected': true, 'name': 'domicilio2_piso_1', 'displayed_column_name': 'domicilio2_piso_1'},
   {'id': 'checkbox_domicilio2_puerta_1', 'selected': true, 'name': 'domicilio2_puerta_1', 'displayed_column_name': 'domicilio2_puerta_1'},
   {'id': 'checkbox_domicilio2_poblacion_1', 'selected': true, 'name': 'domicilio2_poblacion_1', 'displayed_column_name': 'domicilio2_poblacion_1'},
   {'id': 'checkbox_domicilio2_codigo_postal_1', 'selected': true, 'name': 'domicilio2_codigo_postal_1', 'displayed_column_name': 'domicilio2_codigo_postal_1'},
   {'id': 'checkbox_domicilio2_provincia_1', 'selected': true, 'name': 'domicilio2_provincia_1', 'displayed_column_name': 'domicilio2_provincia_1'},
   {'id': 'checkbox_domicilio2_telefono_1', 'selected': true, 'name': 'domicilio2_telefono_1', 'displayed_column_name': 'domicilio2_telefono_1'},
   {'id': 'checkbox_cuenta_bancaria_titular', 'selected': true, 'name': 'cuenta_bancaria_titular', 'displayed_column_name': 'cuenta_bancaria_titular'},
   {'id': 'checkbox_cuenta_bancaria_dni', 'selected': true, 'name': 'cuenta_bancaria_dni', 'displayed_column_name': 'cuenta_bancaria_dni'},
   {'id': 'checkbox_cuenta_bancaria_iban_1', 'selected': true, 'name': 'cuenta_bancaria_iban_1', 'displayed_column_name': 'cuenta_bancaria_iban_1'},
   {'id': 'checkbox_cuenta_bancaria_iban_2', 'selected': true, 'name': 'cuenta_bancaria_iban_2', 'displayed_column_name': 'cuenta_bancaria_iban_2'},
   {'id': 'checkbox_cuenta_bancaria_iban_3', 'selected': true, 'name': 'cuenta_bancaria_iban_3', 'displayed_column_name': 'cuenta_bancaria_iban_3'},
   {'id': 'checkbox_cuenta_bancaria_iban_4', 'selected': true, 'name': 'cuenta_bancaria_iban_4', 'displayed_column_name': 'cuenta_bancaria_iban_4'},
   {'id': 'checkbox_cuenta_bancaria_iban_5', 'selected': true, 'name': 'cuenta_bancaria_iban_5', 'displayed_column_name': 'cuenta_bancaria_iban_5'},
   {'id': 'checkbox_comentarios', 'selected': true, 'name': 'comentarios', 'displayed_column_name': 'comentarios'},
   {'id': 'checkbox_checkbox_usuario_leida_cesion_imagenes', 'selected': true, 'name': 'checkbox_usuario_leida_cesion_imagenes', 'displayed_column_name': 'checkbox_usuario_leida_cesion_imagenes'},
   {'id': 'checkbox_checkbox_usuario_cesion_imagenes', 'selected': true, 'name': 'checkbox_usuario_cesion_imagenes', 'displayed_column_name': 'checkbox_usuario_cesion_imagenes'}
 ];

  //variables para gestionar que se realice la accioón de mostrar/ocultar las columnas
   show_tut_1_email;
   show_password;
   show_tut_1_dni;
   show_tut_1_apellido1;
   show_tut_1_apellido2;
   show_tut_1_nombre;
   show_tut_1_telefono1;
   show_tut_1_telefono2;
   show_tut_2_email;
   show_tut_2_dni;
   show_tut_2_apellido1;
   show_tut_2_apellido2;
   show_tut_2_nombre;
   show_tut_2_telefono1;
   show_tut_2_telefono2;
   show_domicilio_calle_1;
   show_domicilio_numero_1;
   show_domicilio_escalera_1;
   show_domicilio_piso_1;
   show_domicilio_puerta_1;
   show_domicilio_poblacion_1;
   show_domicilio_codigo_postal_1;
   show_domicilio_provincia_1;
   show_domicilio_telefono_1;
   show_domicilio2_calle_1;
   show_domicilio2_numero_1;
   show_domicilio2_escalera_1;
   show_domicilio2_piso_1;
   show_domicilio2_puerta_1;
   show_domicilio2_poblacion_1;
   show_domicilio2_codigo_postal_1;
   show_domicilio2_provincia_1;
   show_domicilio2_telefono_1;
   show_cuenta_bancaria_titular;
   show_cuenta_bancaria_dni;
   show_cuenta_bancaria_iban_1;
   show_cuenta_bancaria_iban_2;
   show_cuenta_bancaria_iban_3;
   show_cuenta_bancaria_iban_4;
   show_cuenta_bancaria_iban_5;
   show_comentarios;
   show_checkbox_usuario_leida_cesion_imagenes;
   show_checkbox_usuario_cesion_imagenes;



  user;
  userId = '';
  ampa;
  datosdisponibles = false;

  // datos de la tabla
  displayedColumns = ['select','bloqueador', 'tut_1_email', 'password', 'tut_1_dni', 'tut_1_apellido1', 'tut_1_apellido2', 'tut_1_nombre', 'tut_1_telefono1', 'tut_1_telefono2', 'tut_2_email', 'tut_2_dni', 'tut_2_apellido1', 'tut_2_apellido2', 'tut_2_nombre', 'tut_2_telefono1', 'tut_2_telefono2', 'domicilio_calle_1', 'domicilio_numero_1', 'domicilio_escalera_1', 'domicilio_piso_1', 'domicilio_puerta_1', 'domicilio_poblacion_1', 'domicilio_codigo_postal_1', 'domicilio_provincia_1','domicilio_telefono_1', 'domicilio2_calle_1', 'domicilio2_numero_1', 'domicilio2_escalera_1', 'domicilio2_piso_1', 'domicilio2_puerta_1', 'domicilio2_poblacion_1', 'domicilio2_codigo_postal_1', 'domicilio2_provincia_1', 'domicilio2_telefono_1', 'cuenta_bancaria_titular', 'cuenta_bancaria_dni', 'cuenta_bancaria_iban_1', 'cuenta_bancaria_iban_2', 'cuenta_bancaria_iban_3', 'cuenta_bancaria_iban_4', 'cuenta_bancaria_iban_5','comentarios','checkbox_usuario_leida_cesion_imagenes','checkbox_usuario_cesion_imagenes'];
  //, 'acciones'];


  selection = new SelectionModel<ListadoUsuariosData>(true, []);

  dataSource: MatTableDataSource<ListadoUsuariosData>;
  usuarios: ListadoUsuariosData[] = [];
  initialSelection = [];
  allowMultiSelect = true;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor( private router: Router ) {


    console.log('constructor')
    /* COMENTARIO DE JOSE MIGUEL. Falta crear un servicio que busque y compruebe los datos del ampa
    deberiamos hacerlo como un provider que haga la llamada al ws y hacerlo
    funcionar como un guard para todas las rutas. Aparte habría que complementarlo
    con autentificación de usuarios*/


  }



   ngOnInit() {

     console.log('ngoninit')


     this.dataSource = new MatTableDataSource(this.usuarios);
     this.dataSource.paginator = this.paginator;
     this.dataSource.sort = this.sort;
     //obtener datos del usuario admin logueado
     this.userId = localStorage.getItem('userId');
     console.log('UserId', this.userId);
     if(!this.userId){
       console.log('peto en listados-usuarios aqui')
       this.router.navigate[('')]
     } else {
       firebase.firestore().collection('admins').doc(this.userId)
       .get()
       .then((doc)=>{
         this.user = doc.data();
         console.log('User object', this.user)

         this.obtenerListadoUsuarios();
       })
     }
     this.setMostrarOcultarTrue();

     this.show_tut_1_email = this.data.find(o => o.name === "tut_1_email");
     this.show_password = this.data.find(o => o.name === "password");
     this.show_tut_1_dni = this.data.find(o => o.name === "tut_1_dni");
     this.show_tut_1_apellido1 = this.data.find(o => o.name === "tut_1_apellido1");
     this.show_tut_1_apellido2 = this.data.find(o => o.name === "tut_1_apellido2");
     this.show_tut_1_nombre = this.data.find(o => o.name === "tut_1_nombre");
     this.show_tut_1_telefono1 = this.data.find(o => o.name === "tut_1_telefono1");
     this.show_tut_1_telefono2 = this.data.find(o => o.name === "tut_1_telefono2");
     this.show_tut_2_email = this.data.find(o => o.name === "tut_2_email");
     this.show_tut_2_dni = this.data.find(o => o.name === "tut_2_dni");
     this.show_tut_2_apellido1 = this.data.find(o => o.name === "tut_2_apellido1");
     this.show_tut_2_apellido2 = this.data.find(o => o.name === "tut_2_apellido2");
     this.show_tut_2_nombre = this.data.find(o => o.name === "tut_2_nombre");
     this.show_tut_2_telefono1 = this.data.find(o => o.name === "tut_2_telefono1");
     this.show_tut_2_telefono2 = this.data.find(o => o.name === "tut_2_telefono2");
     this.show_domicilio_calle_1 = this.data.find(o => o.name === "domicilio_calle_1");
     this.show_domicilio_numero_1 = this.data.find(o => o.name === "domicilio_numero_1");
     this.show_domicilio_escalera_1 = this.data.find(o => o.name === "domicilio_escalera_1");
     this.show_domicilio_piso_1 = this.data.find(o => o.name === "domicilio_piso_1");
     this.show_domicilio_puerta_1 = this.data.find(o => o.name === "domicilio_puerta_1");
     this.show_domicilio_poblacion_1 = this.data.find(o => o.name === "domicilio_poblacion_1");
     this.show_domicilio_codigo_postal_1 = this.data.find(o => o.name === "domicilio_codigo_postal_1");
     this.show_domicilio_provincia_1 = this.data.find(o => o.name === "domicilio_provincia_1");
     this.show_domicilio_telefono_1 = this.data.find(o => o.name === "domicilio_telefono_1");
     this.show_domicilio2_calle_1 = this.data.find(o => o.name === "domicilio2_calle_1");
     this.show_domicilio2_numero_1 = this.data.find(o => o.name === "domicilio2_numero_1");
     this.show_domicilio2_escalera_1 = this.data.find(o => o.name === "domicilio2_escalera_1");
     this.show_domicilio2_piso_1 = this.data.find(o => o.name === "domicilio2_piso_1");
     this.show_domicilio2_puerta_1 = this.data.find(o => o.name === "domicilio2_puerta_1");
     this.show_domicilio2_poblacion_1 = this.data.find(o => o.name === "domicilio2_poblacion_1");
     this.show_domicilio2_codigo_postal_1 = this.data.find(o => o.name === "domicilio2_codigo_postal_1");
     this.show_domicilio2_provincia_1 = this.data.find(o => o.name === "domicilio2_provincia_1");
     this.show_domicilio2_telefono_1 = this.data.find(o => o.name === "domicilio2_telefono_1");
     this.show_cuenta_bancaria_titular = this.data.find(o => o.name === "cuenta_bancaria_titular");
     this.show_cuenta_bancaria_dni = this.data.find(o => o.name === "cuenta_bancaria_dni");
     this.show_cuenta_bancaria_iban_1 = this.data.find(o => o.name === "cuenta_bancaria_iban_1");
     this.show_cuenta_bancaria_iban_2 = this.data.find(o => o.name === "cuenta_bancaria_iban_2");
     this.show_cuenta_bancaria_iban_3 = this.data.find(o => o.name === "cuenta_bancaria_iban_3");
     this.show_cuenta_bancaria_iban_4 = this.data.find(o => o.name === "cuenta_bancaria_iban_4");
     this.show_cuenta_bancaria_iban_5 = this.data.find(o => o.name === "cuenta_bancaria_iban_5");
     this.show_comentarios = this.data.find(o => o.name === "comentarios");
     this.show_checkbox_usuario_leida_cesion_imagenes = this.data.find(o => o.name === "checkbox_usuario_leida_cesion_imagenes");
     this.show_checkbox_usuario_cesion_imagenes = this.data.find(o => o.name === "checkbox_usuario_cesion_imagenes");
  }

  // nos traemos los usuarios del ampa utilizando el id de ampa que tiene el usuario en su documento
  obtenerListadoUsuarios(){
    console.log('obtenerListadoUsuarios')
    firebase.firestore().collection('usuarios')
    .where('ampa','==', this.user.ampa)
    .get()
    .then((snapshot)=>{
      snapshot.forEach((doc)=>{
        console.log('usuarios doc',doc)
        var elemento = doc.data();
        elemento.id = doc.id;
        //hacemos el push
        this.usuarios = [...this.usuarios, <ListadoUsuariosData>elemento];
      })
      this.dataSource = new MatTableDataSource(this.usuarios);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;

      this.datosdisponibles = true;
    })
  }



  // mostramos los datos del usuario id
  ver(row){
    console.log('Ver ', row.id);
    this.router.navigate(['/admin/listados-usuarios/ver/' + row.id]);
  }

  // eliminar usuarios seleccionados
  eliminar(){
      this.selection.selected.forEach((usuario) => {
        firebase.firestore().collection('usuarios').doc(usuario.id)
        .delete()
        .catch(error => {console.log(error); })
        .then(()=>{
          console.log('Borrado usuario ' + usuario.id)
        })
      });
      this.usuarios = [];
      this.obtenerListadoUsuarios();
  }

  // actualizamos los datos de algunos campos del usuario id
  editar(row){
    console.log('Editado ', row.id)
    this.router.navigate(['/admin/listados-usuarios/editar/' + row.id])
  }

  //exportamos a xlsx datos de usuarios seleccionados
  exportToExcel() {
    for (var i = 0; i < this.selection.selected.length; i++) {
      for (var j = 0; j < this.data.length; j++) {
      //console.log('item:',this.selection.selected[i])
      if ((this.data[j].id === 'checkbox_tut_1_email') && (this.data[j].selected === false)) delete this.selection.selected[i].tut_1_email;
      if ((this.data[j].id === 'checkbox_password') && (this.data[j].selected === false)) delete this.selection.selected[i].password;
      if ((this.data[j].id === 'checkbox_tut_1_dni') && (this.data[j].selected === false)) delete this.selection.selected[i].tut_1_dni;
      if ((this.data[j].id === 'checkbox_tut_1_apellido1') && (this.data[j].selected === false)) delete this.selection.selected[i].tut_1_apellido1;
      if ((this.data[j].id === 'checkbox_tut_1_apellido2') && (this.data[j].selected === false)) delete this.selection.selected[i].tut_1_apellido2;
      if ((this.data[j].id === 'checkbox_tut_1_nombre') && (this.data[j].selected === false)) delete this.selection.selected[i].tut_1_nombre;
      if ((this.data[j].id === 'checkbox_tut_1_telefono1') && (this.data[j].selected === false)) delete this.selection.selected[i].tut_1_telefono1;
      if ((this.data[j].id === 'checkbox_tut_1_telefono2') && (this.data[j].selected === false)) delete this.selection.selected[i].tut_1_telefono2;
      if ((this.data[j].id === 'checkbox_tut_2_email') && (this.data[j].selected === false)) delete this.selection.selected[i].tut_2_email;
      if ((this.data[j].id === 'checkbox_tut_2_dni') && (this.data[j].selected === false)) delete this.selection.selected[i].tut_2_dni;
      if ((this.data[j].id === 'checkbox_tut_2_apellido1') && (this.data[j].selected === false)) delete this.selection.selected[i].tut_2_apellido1;
      if ((this.data[j].id === 'checkbox_tut_2_apellido2') && (this.data[j].selected === false)) delete this.selection.selected[i].tut_2_apellido2;
      if ((this.data[j].id === 'checkbox_tut_2_nombre') && (this.data[j].selected === false)) delete this.selection.selected[i].tut_2_nombre;
      if ((this.data[j].id === 'checkbox_tut_2_telefono1') && (this.data[j].selected === false)) delete this.selection.selected[i].tut_2_telefono1;
      if ((this.data[j].id === 'checkbox_tut_2_telefono2') && (this.data[j].selected === false)) delete this.selection.selected[i].tut_2_telefono2;
      if ((this.data[j].id === 'checkbox_domicilio_calle_1') && (this.data[j].selected === false)) delete this.selection.selected[i].domicilio_calle_1;
      if ((this.data[j].id === 'checkbox_domicilio_numero_1') && (this.data[j].selected === false)) delete this.selection.selected[i].domicilio_numero_1;
      if ((this.data[j].id === 'checkbox_domicilio_escalera_1') && (this.data[j].selected === false)) delete this.selection.selected[i].domicilio_escalera_1;
      if ((this.data[j].id === 'checkbox_domicilio_piso_1') && (this.data[j].selected === false)) delete this.selection.selected[i].domicilio_piso_1;
      if ((this.data[j].id === 'checkbox_domicilio_puerta_1') && (this.data[j].selected === false)) delete this.selection.selected[i].domicilio_puerta_1;
      if ((this.data[j].id === 'checkbox_domicilio_poblacion_1') && (this.data[j].selected === false)) delete this.selection.selected[i].domicilio_poblacion_1;
      if ((this.data[j].id === 'checkbox_domicilio_codigo_postal_1') && (this.data[j].selected === false)) delete this.selection.selected[i].domicilio_codigo_postal_1;
      if ((this.data[j].id === 'checkbox_domicilio_provincia_1') && (this.data[j].selected === false)) delete this.selection.selected[i].domicilio_provincia_1;
      if ((this.data[j].id === 'checkbox_domicilio_telefono_1') && (this.data[j].selected === false)) delete this.selection.selected[i].domicilio_telefono_1;
      if ((this.data[j].id === 'checkbox_domicilio2_calle_1') && (this.data[j].selected === false)) delete this.selection.selected[i].domicilio2_calle_1;
      if ((this.data[j].id === 'checkbox_domicilio2_numero_1') && (this.data[j].selected === false)) delete this.selection.selected[i].domicilio2_numero_1;
      if ((this.data[j].id === 'checkbox_domicilio2_escalera_1') && (this.data[j].selected === false)) delete this.selection.selected[i].domicilio2_escalera_1;
      if ((this.data[j].id === 'checkbox_domicilio2_piso_1') && (this.data[j].selected === false)) delete this.selection.selected[i].domicilio2_piso_1;
      if ((this.data[j].id === 'checkbox_domicilio2_puerta_1') && (this.data[j].selected === false)) delete this.selection.selected[i].domicilio2_puerta_1;
      if ((this.data[j].id === 'checkbox_domicilio2_poblacion_1') && (this.data[j].selected === false)) delete this.selection.selected[i].domicilio2_poblacion_1;
      if ((this.data[j].id === 'checkbox_domicilio2_codigo_postal_1') && (this.data[j].selected === false)) delete this.selection.selected[i].domicilio2_codigo_postal_1;
      if ((this.data[j].id === 'checkbox_domicilio2_provincia_1') && (this.data[j].selected === false)) delete this.selection.selected[i].domicilio2_provincia_1;
      if ((this.data[j].id === 'checkbox_domicilio2_telefono_1') && (this.data[j].selected === false)) delete this.selection.selected[i].domicilio2_telefono_1;
      if ((this.data[j].id === 'checkbox_cuenta_bancaria_titular') && (this.data[j].selected === false)) delete this.selection.selected[i].cuenta_bancaria_titular;
      if ((this.data[j].id === 'checkbox_cuenta_bancaria_dni') && (this.data[j].selected === false)) delete this.selection.selected[i].cuenta_bancaria_dni;
      if ((this.data[j].id === 'checkbox_cuenta_bancaria_iban_1') && (this.data[j].selected === false)) delete this.selection.selected[i].cuenta_bancaria_iban_1;
      if ((this.data[j].id === 'checkbox_cuenta_bancaria_iban_2') && (this.data[j].selected === false)) delete this.selection.selected[i].cuenta_bancaria_iban_2;
      if ((this.data[j].id === 'checkbox_cuenta_bancaria_iban_3') && (this.data[j].selected === false)) delete this.selection.selected[i].cuenta_bancaria_iban_3;
      if ((this.data[j].id === 'checkbox_cuenta_bancaria_iban_4') && (this.data[j].selected === false)) delete this.selection.selected[i].cuenta_bancaria_iban_4;
      if ((this.data[j].id === 'checkbox_cuenta_bancaria_iban_5') && (this.data[j].selected === false)) delete this.selection.selected[i].cuenta_bancaria_iban_5;
      if ((this.data[j].id === 'checkbox_comentarios') && (this.data[j].selected === false)) delete this.selection.selected[i].comentarios;
      if ((this.data[j].id === 'checkbox_checkbox_usuario_leida_cesion_imagenes') && (this.data[j].selected === false)) delete this.selection.selected[i].checkbox_usuario_leida_cesion_imagenes;
      if ((this.data[j].id === 'checkbox_checkbox_usuario_cesion_imagenes') && (this.data[j].selected === false)) delete this.selection.selected[i].checkbox_usuario_cesion_imagenes;
        //delete this.selection.selected[i].tut_1_email;
    }
}



    console.log('this.selection',this.selection)

    var ws = XLSX.utils.json_to_sheet(this.selection.selected);
    var wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "ListadoUsuarios");
    XLSX.writeFile(wb, 'usuarios.xlsx');
  }

  exportToPDF() {

  }


  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected == numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
    this.selection.clear() :
    this.dataSource.data.forEach(row => this.selection.select(row));
  }

  change(event){

    console.log('event:',event.source.id)

    this.toggleMostrarOcultarItem(event.source.id);

    if (event.source.id === 'checkbox_tut_1_email') this.show_tut_1_email = event.checked;
    if (event.source.id === 'checkbox_password') this.show_password = event.checked;
    if (event.source.id === 'checkbox_tut_1_dni') this.show_tut_1_dni = event.checked;
    if (event.source.id === 'checkbox_tut_1_apellido1') this.show_tut_1_apellido1 = event.checked;
    if (event.source.id === 'checkbox_tut_1_apellido2') this.show_tut_1_apellido2 = event.checked;
    if (event.source.id === 'checkbox_tut_1_nombre') this.show_tut_1_nombre = event.checked;
    if (event.source.id === 'checkbox_tut_1_telefono1') this.show_tut_1_telefono1 = event.checked;
    if (event.source.id === 'checkbox_tut_1_telefono2') this.show_tut_1_telefono2 = event.checked;
    if (event.source.id === 'checkbox_tut_2_email') this.show_tut_2_email = event.checked;
    if (event.source.id === 'checkbox_tut_2_dni') this.show_tut_2_dni = event.checked;
    if (event.source.id === 'checkbox_tut_2_apellido1') this.show_tut_2_apellido1 = event.checked;
    if (event.source.id === 'checkbox_tut_2_apellido2') this.show_tut_2_apellido2 = event.checked;
    if (event.source.id === 'checkbox_tut_2_nombre') this.show_tut_2_nombre = event.checked;
    if (event.source.id === 'checkbox_tut_2_telefono1') this.show_tut_2_telefono1 = event.checked;
    if (event.source.id === 'checkbox_tut_2_telefono2') this.show_tut_2_telefono2 = event.checked;
    if (event.source.id === 'checkbox_domicilio_calle_1') this.show_domicilio_calle_1 = event.checked;
    if (event.source.id === 'checkbox_domicilio_numero_1') this.show_domicilio_numero_1 = event.checked;
    if (event.source.id === 'checkbox_domicilio_escalera_1') this.show_domicilio_escalera_1 = event.checked;
    if (event.source.id === 'checkbox_domicilio_piso_1') this.show_domicilio_piso_1 = event.checked;
    if (event.source.id === 'checkbox_domicilio_puerta_1') this.show_domicilio_puerta_1 = event.checked;
    if (event.source.id === 'checkbox_domicilio_poblacion_1') this.show_domicilio_poblacion_1 = event.checked;
    if (event.source.id === 'checkbox_domicilio_codigo_postal_1') this.show_domicilio_codigo_postal_1 = event.checked;
    if (event.source.id === 'checkbox_domicilio_provincia_1') this.show_domicilio_provincia_1 = event.checked;
    if (event.source.id === 'checkbox_domicilio_telefono_1') this.show_domicilio_telefono_1 = event.checked;
    if (event.source.id === 'checkbox_domicilio2_calle_1') this.show_domicilio2_calle_1 = event.checked;
    if (event.source.id === 'checkbox_domicilio2_numero_1') this.show_domicilio2_numero_1 = event.checked;
    if (event.source.id === 'checkbox_domicilio2_escalera_1') this.show_domicilio2_escalera_1 = event.checked;
    if (event.source.id === 'checkbox_domicilio2_piso_1') this.show_domicilio2_piso_1 = event.checked;
    if (event.source.id === 'checkbox_domicilio2_puerta_1') this.show_domicilio2_puerta_1 = event.checked;
    if (event.source.id === 'checkbox_domicilio2_poblacion_1') this.show_domicilio2_poblacion_1 = event.checked;
    if (event.source.id === 'checkbox_domicilio2_codigo_postal_1') this.show_domicilio2_codigo_postal_1 = event.checked;
    if (event.source.id === 'checkbox_domicilio2_provincia_1') this.show_domicilio2_provincia_1 = event.checked;
    if (event.source.id === 'checkbox_domicilio2_telefono_1') this.show_domicilio2_telefono_1 = event.checked;
    if (event.source.id === 'checkbox_cuenta_bancaria_titular') this.show_cuenta_bancaria_titular = event.checked;
    if (event.source.id === 'checkbox_cuenta_bancaria_dni') this.show_cuenta_bancaria_dni = event.checked;
    if (event.source.id === 'checkbox_cuenta_bancaria_iban_1') this.show_cuenta_bancaria_iban_1 = event.checked;
    if (event.source.id === 'checkbox_cuenta_bancaria_iban_2') this.show_cuenta_bancaria_iban_2 = event.checked;
    if (event.source.id === 'checkbox_cuenta_bancaria_iban_3') this.show_cuenta_bancaria_iban_3 = event.checked;
    if (event.source.id === 'checkbox_cuenta_bancaria_iban_4') this.show_cuenta_bancaria_iban_4 = event.checked;
    if (event.source.id === 'checkbox_cuenta_bancaria_iban_5') this.show_cuenta_bancaria_iban_5 = event.checked;
    if (event.source.id === 'checkbox_comentarios') this.show_comentarios = event.checked;
    if (event.source.id === 'checkbox_checkbox_usuario_leida_cesion_imagenes') this.show_checkbox_usuario_leida_cesion_imagenes = event.checked;
    if (event.source.id === 'checkbox_checkbox_usuario_cesion_imagenes') this.show_checkbox_usuario_cesion_imagenes = event.checked;

  }

  setMostrarOcultarTrue() {

    for (var i = 0; i < this.data.length; i++) {
        this.data[i].selected = true;
        return;
    }
  }

  toggleMostrarOcultarItem(event_source_id) {
    for (var i = 0; i < this.data.length; i++) {
      if (this.data[i].id === event_source_id) {
        this.data[i].selected = !this.data[i].selected;
        return;
      }
    }
  }





  // toggleAll(){
  //   this.seleccionarTodo = !this.seleccionarTodo;
  //   this.toggleMostrarOcultarItem('seleccionarTodo');
  //
  //   for (var i = 0; i < this.data.length; i++) {
  //       this.data[i].selected = !this.data[i].selected;
  //   }
  //
  //   this.show_tut_1_email = event.checked;
  //   this.show_password = event.checked;
  //   this.show_tut_1_dni = event.checked;
  //   this.show_tut_1_apellido1 = event.checked;
  //   this.show_tut_1_apellido2 = event.checked;
  //   this.show_tut_1_nombre = event.checked;
  //   this.show_tut_1_telefono1 = event.checked;
  //   this.show_tut_1_telefono2 = event.checked;
  //   this.show_tut_2_email = event.checked;
  //   this.show_tut_2_dni = event.checked;
  //   this.show_tut_2_apellido1 = event.checked;
  //   this.show_tut_2_apellido2 = event.checked;
  //   this.show_tut_2_nombre = event.checked;
  //   this.show_tut_2_telefono1 = event.checked;
  //   this.show_tut_2_telefono2 = event.checked;
  //   this.show_domicilio_calle_1 = event.checked;
  //   this.show_domicilio_numero_1 = event.checked;
  //   this.show_domicilio_escalera_1 = event.checked;
  //   this.show_domicilio_piso_1 = event.checked;
  //   this.show_domicilio_puerta_1 = event.checked;
  //   this.show_domicilio_poblacion_1 = event.checked;
  //   this.show_domicilio_codigo_postal_1 = event.checked;
  //   this.show_domicilio_provincia_1 = event.checked;
  //   this.show_domicilio_telefono_1 = event.checked;
  //   this.show_domicilio2_calle_1 = event.checked;
  //   this.show_domicilio2_numero_1 = event.checked;
  //   this.show_domicilio2_escalera_1 = event.checked;
  //   this.show_domicilio2_piso_1 = event.checked;
  //   this.show_domicilio2_puerta_1 = event.checked;
  //   this.show_domicilio2_poblacion_1 = event.checked;
  //   this.show_domicilio2_codigo_postal_1 = event.checked;
  //   this.show_domicilio2_provincia_1 = event.checked;
  //   this.show_domicilio2_telefono_1 = event.checked;
  //   this.show_cuenta_bancaria_titular = event.checked;
  //   this.show_cuenta_bancaria_dni = event.checked;
  //   this.show_cuenta_bancaria_iban_1 = event.checked;
  //   this.show_cuenta_bancaria_iban_2 = event.checked;
  //   this.show_cuenta_bancaria_iban_3 = event.checked;
  //   this.show_cuenta_bancaria_iban_4 = event.checked;
  //   this.show_cuenta_bancaria_iban_5 = event.checked;
  //   this.show_comentarios = event.checked;
  //   this.show_checkbox_usuario_leida_cesion_imagenes = event.checked;
  //   this.show_checkbox_usuario_cesion_imagenes = event.checked;
  //
  // }

}

export interface ListadoUsuariosData {
  id: string;
  rol: string;
  tut_1_email: string;
  password: string;
  tut_1_dni: string;
  tut_1_apellido1: string;
  tut_1_apellido2: string;
  tut_1_nombre: string;
  tut_1_telefono1: string;
  tut_1_telefono2: string;
  tut_2_email: string;
  tut_2_dni: string;
  tut_2_apellido1: string;
  tut_2_apellido2: string;
  tut_2_nombre: string;
  tut_2_telefono1: string;
  tut_2_telefono2: string;
  domicilio_calle_1: string;
  domicilio_numero_1: string;
  domicilio_escalera_1: string;
  domicilio_piso_1: string;
  domicilio_puerta_1: string;
  domicilio_poblacion_1: string;
  domicilio_codigo_postal_1: string;
  domicilio_provincia_1: string;
  domicilio_telefono_1: string;
  domicilio2_calle_1: string;
  domicilio2_numero_1: string;
  domicilio2_escalera_1: string;
  domicilio2_piso_1: string;
  domicilio2_puerta_1: string;
  domicilio2_poblacion_1: string;
  domicilio2_codigo_postal_1: string;
  domicilio2_provincia_1: string;
  domicilio2_telefono_1: string;
  cuenta_bancaria_titular: string;
  cuenta_bancaria_dni: string;
  cuenta_bancaria_iban_1: string;
  cuenta_bancaria_iban_2: string;
  cuenta_bancaria_iban_3: string;
  cuenta_bancaria_iban_4: string;
  cuenta_bancaria_iban_5: string;
  comentarios: string;
  checkbox_usuario_leida_cesion_imagenes: string;
  checkbox_usuario_cesion_imagenes: string;
  }



// WEBPACK FOOTER //
// ./src/app/adminlistados-usuarios/adminlistados-usuarios.component.ts